import store from '../../store/index.js'
export default {
	//留
	browerChange:{
		title:'EXSOFT Technology',
		keywords:'Language laboratory, wireless language laboratory, Internet language laboratory, simultaneous interpretation, smart classroom, smart classroom interaction, paperless conference, multimedia teaching, integrated control teaching, smart ward, nurse patient communication, information intercom, bedside interaction, nursing whiteboard, doorside information, mobile nursing, ward management platform',
		description:'Focusing on products services in the fields of education and medical treatment, providing excellent service guarantees for schools and hospitals',
		bottomMark:'EXSOFT Technology Co.Ltd All rights reserved'
	},
	//留
	tabList: [{
			id: 1,
			name: 'Home'
		},
		{
			id: 2,
			name: 'About'
		},
		{
			id: 3,
			name: "Products"
		},
		// {
		// 	id: 4,
		// 	name: 'Customer'
		// },
		// {
		// 	id: 5,
		// 	name: 'News'
		// },
		// {
		// 	id: 5,
		// 	name: 'Career'
		// },
		{
			id: 6,
			name: 'Contact'
		}
	],
	
	//留
	product:{
		productChange:'click to know',
		tabList:[{
				id: 1,
				name: 'Translation Interpretation'
			},{
				id: 2,
				name: 'Language Lab'
			},{
				id: 3,
				name: 'Smart Campus'
			},{
				id: 4,
				name: 'Smart Ward'
			},{
				id: 5,
				name: 'Paperless meetings'
			},{
				id: 6,
				name: 'E-classroom'
			}]
	},
	
	//留
	bottom:{
		class1:{
			title:'Home',
			text1:'Product Center',
			text2:'About us',
			text3:'News',
		},
		class2:{
			title:'About us',
			text1:'Company Profile',
			text2:'Development history',
			text3:'Qualifications honors',
			text4:'corporate culture',
		},
		class3:{
			title:'Product',
			text1:'Foreign Language Products',
			text2:'Smart Campus',
			text3:'Smart Ward',
			text4:'Paperless meetings',
		},
		class4:{
			title:'Customer Case',
		},
		class5:{
			title:'News',
		},
		class6:{
			title:'Contact Us',
		}
		
	},
	
	//留
	right:{
		weixin:'WeChat customer service',
		salePhone:'sale phone',
		phone:{
			text:"Contact Us"
		},
		opinion:{
			title:"Submit Feedback",
			text1:"Name",
			input1:'PPlease enter your namer',
			text2:"corporate name",
			input2:"Please enter the company name",
			text3:"Phone number",
			input3:"Please enter your phone number",
			text4:"Feedback Content",
			input4:"Please enter content",
			text5:"Submit Feedback",
			text6:"Email",
			input5:'Please enter your email address',
			text7:"Sale QR code:",
			text8:"QR code of official account:",
			text9:"Submitting feedback"
		}
	},
	
	//留
	aboutUs:{
		title:'About us',
		title2:'HISTORY',
		title3:'CERTIFICATES',
		tabList: [
			{
				id: 1,
				name: 'Company Profile',
				img_on:require('@/assets/img/news/frame.png'),
				img_off:require('@/assets/img/news/frameHover.png'),
			},
			{
				id: 2,
				name: 'Qualifications honors',
				img_on:require('@/assets/img/news/honour.png'),
				img_off:require('@/assets/img/news/honourHover.png'),
			},
			{
				id: 3,
				name: 'Corporate culture',
				img_on:require('@/assets/img/news/civilization.png'),
				img_off:require('@/assets/img/news/civilizationHover.png'),
			}		
		],
		coreConcepts:{
			title:'Core concepts',
			content:'Service, trust, win-win situation, innovation',
			list:[{
				id:1,
				title:'Our Vision',
				content:'Focusing on products services in the fields of education and medical treatment'
			},
			{
				id:2,
				title:'Our Mission',
				content:'Achieve Customers, Achieve Brands, Achieve Employees'
			},
			{
				id:4,
				title:'Corporate Values',
				content:'Customer first, respect for individuals, integrity, teamwork, pursuit of excellence'
			}]
		}
	},
	//留
	humanResources:{
		title:'Human resources',
		topList: [{
				id: 1,
				name: "Recruitment position's"
			}
		],
		title2:"Recruitment position's",
		tableText1:'Job Responsibilities',
		tableText2:'job content',
		tableText3:'working hours',
		tableText4:'Compensation and benefits',
		tableText5:'Position Name:',
		tableText6:'record of formal schooling:',
		tableText7:'pay:',
		tableText8:'Release time:',
	},
	
	topImageUrl:{
		about:require('@/assets/img/topImage/en1.webp'),
		product:require('@/assets/img/topImage/en2.webp'),
		contact:require('@/assets/img/topImage/en3.webp'),
	}
}
